import { apiSlice } from './apiSlice';

export interface NotificationItem {
  id: number;
  title: string;
  body: string;
  type: string;
  data: Record<string, any>;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  [key: string]: any;
}

export interface NotificationGroup {
  [key: string]: NotificationItem[];
}

export interface NotificationResponse {
  data: NotificationGroup;
  pagination: {
    total: number;
    limit: number;
    currentPage: number;
    totalPage: number;
  };
}

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationResponse, { type?: string } | void>({
      query: (params = {}) => {
        return {
          url: `/notifications`,
          method: 'GET',
          params: { t: Date.now() },
        };
      },
    }),
  }),
});

export const { useGetNotificationsQuery } = notificationApi;
